<div [hidden]="view === 'steps'">
	<pannel [title]="'Recherche'" [expandable]="true" [folded]="true">
		<documents-pa-search (onApplyFilters)="filterResults$.next($event)"></documents-pa-search>
	</pannel>
	<pannel [title]="'Liste des documents personnes averties'" [expandable]="true" >
		<liste-documents-pa  [filtersSubject]="filterResults$" (ajouterDocument)="ajouterDocumentPa()" 
			(modifierDocument)="modifierDocumentPa($event)" [refreshCommands]="initListCommands" >
		</liste-documents-pa> 
	</pannel>
</div>

<div [hidden]="currentCategorie === paCategories.EOL">
	<documents-pa-stepper-pv  *ngIf="(steps$ | async) as steps" [documentPaSteps]="steps" [editCommand]="editCommands"
		(viewChange)="changeView($event)" (parcEnergieHasChange)="handleParcEnergieChange($event)" [hidden]="view === 'list'" >
	</documents-pa-stepper-pv>
</div>

<div [hidden]="currentCategorie === paCategories.PV">
	<documents-pa-stepper-eol  *ngIf="(steps$ | async) as steps" [documentPaSteps]="steps" [editCommand]="editCommands" 
		(viewChange)="changeView($event)" (parcEnergieHasChange)="handleParcEnergieChange($event)" [hidden]="view === 'list'" >
	</documents-pa-stepper-eol>
</div>
